import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/schilddruese.jpg"

const Schilddrüsenuntersuchung = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung -  Schilddrüsenuntersuchung </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Schilddrüsenhormone beeinflussen viel Stoffwechselvorgänge des Körpers. Fehlfunktionen der Schilddrüse haben deshalb oft Erkrankungen zur Folge, die wenig charakteristische Symptome verursachen. Eine umfassende Schilddrüsenuntersuchung stützt sich im Wesentlichen auf drei diagnostische Verfahren:
                        <ul>
                            <li>Mit Hilfe einer <b> Blutuntersuchung</b> erfahren Sie, ob Ihre Schilddrüse Hormone in normaler Menge produziert oder ob eine Über- oder Unterfunktion vorliegt, bzw. ob eine Autoimmunerkrankung zugrunde liegt.</li>
                            <li>Die <b> Ultraschalluntersuchung </b> gibt Aufschluss über Größe und Struktur der Schilddrüse und hilft dabei, Knoten genauer zu untersuchen.( es handelt sich dabei um eine schmerzlose Untersuchung mit Gel im Halsbereich)</li>
                        </ul>
                        Falls die erhobenen Befunde Auffälligkeiten zeigen, kann eine Überweisung zu einer Schilddrüsenszintigraphie notwendig sein, welche erkennen lässt, ob ein Schilddrüsenknoten keine oder zu viele Schilddrüsenhormone produziert.
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Schilddrüsenuntersuchung;